import { Action, Base } from 'survey-core';
import { ReactElementFactory, SurveyElementBase } from 'survey-react-ui';

interface IActionBarItemProps {
  item: Action;
}

export class SurveyAction extends SurveyElementBase<IActionBarItemProps, any> {
  get item() {
    return this.props.item;
  }
  protected getStateElement(): Base {
    return this.item;
  }

  renderElement() {
    const itemComponent = ReactElementFactory.Instance.createElement(
      this.item.component || 'sv-action-bar-item',
      {
        item: this.item,
      }
    );
    return itemComponent;
  }
}
